<template>
    <div class="tag" :class="{grey, large, outline}" :style="{fontSize: fontSize ? fontSize + 'px' : ''}">
        <slot />
    </div>
</template>

<script>
    export default {
      name: "tag",

      props: {
        text: String,
        fontSize: Number,
        grey: Boolean,
        outline: Boolean,
        large: Boolean
      }
    }
</script>

<style lang="scss" scoped>
    .tag {
        display: inline-block;
        background-color: var(--primary-color);
        padding: 5px 8px;
        color: white;
        border-radius: 5px;
        line-height: 1;
        fill: white;
        font-weight: normal;
        font-size: 14px;

        &.grey {
            background-color: #f5f5f5;
            color: #404040;
        }

        &.outline {
            background-color: transparent;
            border: 1px dashed var(--primary-color);
            color: inherit;
        }

        &.large {
            font-size: 13px;
            padding: 4px 8px;
        }
    }
</style>

